import styled from 'styled-components'

import { CardFooterStyled } from '@ui/elements/Card'

export const ModalCardFooterStyled = styled(CardFooterStyled)`
  text-align: right;
`

ModalCardFooterStyled.displayName = 'ModalCardFooterStyled'
